import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { personBalanc } from 'global/Models/voucherModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { setPersonTotalBalance } from 'redux/reducer/user/userReducer';
import { AppDispatch } from 'redux/store';

export const getPersonTotalBalance = (personId: number) => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.voucherPersonTotalBalanceGetAll, { personId })
    .then((res: IBackendSearchGeneric<personBalanc>) =>
      handleApiThenGeneric<IBackendSearchGeneric<personBalanc>, personBalanc[]>({
        res,
        onSuccessData: (data) => dispatch(setPersonTotalBalance(data)),
        notifFail: false,
        notifSuccess: false,
      })
    )
    .catch(() => {});
};
